<template>
	<span class="user-party-set" :style="upsStyle">
		<template v-for="(p, idx) in partyTags" :key="p.key">
			<img v-if="p.avatar" class="ups-avt" :class="'avatar-'+p.kind" :style="{ left: (idx*H_SHIFT)+'px', zIndex: 5000-idx }" :src="p.avatar" :alt="p.name" :title="p.name">
			<span v-else class="ups-placeholder" :style="{ left: (idx*H_SHIFT)+'px', zIndex: 5000-idx }" :title="p.name"></span>
		</template>
	</span>
</template>

<script setup lang="ts">
import {ref, computed, type CSSProperties} from "vue";
import {UserList} from "@t/util/CommonTypes.ts";
import {usePartyTags} from "@fd/editors/user-select/UserSelectUtils.ts";
import {injectEnv} from "@fd/Environment.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = defineProps<{
	users: UserList
}>();

const env = injectEnv();
const array = computed<(string|number)[]>(() => {
	return Array.isArray(props.users) ? props.users : [];
});

const H_SHIFT = 12;

const { partyTags } = usePartyTags(env, array);

const upsStyle = computed<CSSProperties>(() => {
	const s: CSSProperties = {};
	s.width = (partyTags.value.length * H_SHIFT + (18 - H_SHIFT)) + "px";
	return s;
});
</script>

<style>
.user-party-set {
	display: inline-flex;
	position: relative;
	height: 18px;
	width: 80px;
	vertical-align: middle;
}

.ups-avt, .ups-placeholder {
	position: absolute;
	top: 0;
	left: 0;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	outline: 1px solid #FFFFFF80;
}
.ups-placeholder {
	background-color: color-mix(in srgb, var(--fg) 15%, var(--bg));
}
</style>